var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaveDivider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 249,
    viewBox: "0 0 1280 249",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1280 132.358C1001.5 -160 491.5 393.5 0 0V240.5C314.5 296 959.5 51.2482 1280 194.5V132.358Z",
    fill: "#F9F6EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveDivider);
export default __webpack_public_path__ + "static/media/wave-divider.465fd357d0e5c9caefeb38f11b7d1b98.svg";
export { ForwardRef as ReactComponent };